import { RootState } from '../reducers'
import { FavorieUserItem } from '../../api/Favorites/types'

export const favoritesUserSelectorNew = (state: RootState): FavorieUserItem[] => (state.favoritesUser && state.favoritesUser.favorites ? state.favoritesUser.favorites : [])
